import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
const CenteredFormRow = _ref => {
  let {
    label,
    children,
    labelMd = 3,
    fieldMd = 9,
    outerSpan = 6,
    outerOffset = 3
  } = _ref;
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: outerSpan,
      offset: outerOffset
    }
  }, /*#__PURE__*/React.createElement(Row, null, label && /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: labelMd
  }, label), /*#__PURE__*/React.createElement(Col, {
    md: fieldMd
  }, children))));
};
export default CenteredFormRow;